import { createSlice } from "@reduxjs/toolkit";
import { getMonthOptions } from "../../utils/date-utils";
import { fetchDataSummary } from "./data-summary.action";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  page: 0,
  itemPerPage: 25,
  totalCount: 0,
  filters: {
    year: new Date().getFullYear().toString(),
    month: getMonthOptions()[new Date().getMonth()],
    fromDay: "",
    toDay: "",
    dateRangeStart: null,
    dateRangeEnd: null,
  },
  isExporting: false,
};

const dataSummarySlice = createSlice({
  name: "dataSummary",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
      state.page = 0;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setItemPerPage: (state, action) => {
      state.itemPerPage = action.payload;
      state.page = 0;
    },
    setIsExporting: (state, action) => {
      state.isExporting = action.payload;
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
      state.page = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDataSummary.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchDataSummary.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.records || [];
        state.totalCount = action.payload.total || 0;
      })
      .addCase(fetchDataSummary.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to fetch data summary.";
      });
  },
});

export const {
  setFilters,
  setPage,
  setItemPerPage,
  setIsExporting,
  resetFilters,
} = dataSummarySlice.actions;

export const dataSummaryReducer = dataSummarySlice.reducer;
